import { ChainID } from '@ankr.com/chains-list';

import { BlockchainsCountsMap } from 'modules/stats/types';
import { mapChainIdToPath } from 'modules/chains/utils/mapChainIdToPath';
import { getUniqueArray } from 'modules/common/utils/getUniqueArray';

export interface AggregateTotalRequestsNumberParams {
  blockchainsCountsMap: BlockchainsCountsMap;
  ids: ChainID[];
}

export const aggregateTotalRequestsNumber = ({
  blockchainsCountsMap,
  ids,
}: AggregateTotalRequestsNumberParams) =>
  getUniqueArray(ids.map(id => mapChainIdToPath(id))).reduce(
    (result, id) => result + (blockchainsCountsMap[id] || 0),
    0,
  );
